import populateDocs from './utils/populateDocs';
import FileUploadList from 'emerald-ui/lib/FileUploadList';

export default {
  ...populateDocs([{ component: FileUploadList, componentName: 'FileUploadList' }], 'FileUploadList'),
  description: 'List designed to display a series of FileUploadItems.',
  codeSamples: [
    {
      title: 'Default',
      scope: { FileUploadList },
      whiteBackground: true,
      code: `<FileUploadList
  files={[
    { id: '1', name: 'document.doc', onCancel: () => {} },
    { id: '2', name: 'spreadsheet.xls', onCancel: () => {} },
    { id: '3', name: 'picture.jpg', onCancel: () => {} },
    { id: '4', name: 'picture.png', onCancel: () => {} },
    { id: '5', name: 'picture.gif', onCancel: () => {} },
    { id: '6', name: 'video.mov', onCancel: () => {} },
    { id: '7', name: 'video.avi', onCancel: () => {} },
    { id: '8', name: 'video.mp4', onCancel: () => {} },
    { id: '9', name: 'other-file.zip', onCancel: () => {} }
  ]}
/>`,
    },
  ],
};
